/* __next_internal_client_entry_do_not_use__ SearchProductLink auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { handleGenerateProductLinkProps } from "@faire/retailer/components/SearchProducts/utils";
import { useOnProductClickForSearchPage } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageFilterKeys } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/useSearchPageFilterKeys";
import { useSearchPageProductSearchString } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
/**
 * A client component provides very basic functionality to redirect to pdp.
 */ export var SearchProductLink = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, impressionId = _param_data.impressionId, images = _param_data.images, isPromoted = _param_data.isPromoted, promotedBy = _param_data.promotedBy, badgeList = _param_data.badgeList, brandToken = _param_data.brandToken, selectedProductOptionToken = _param_data.selectedProductOptionToken, bestImage = _param_data.bestImage, children = param.children;
    var onProductClick = useOnProductClickForSearchPage({
        token: productToken,
        isPromoted: isPromoted,
        impressionId: impressionId,
        promotedBy: promotedBy,
        badgeList: badgeList,
        bestImage: bestImage,
        images: images
    }).onProductClick;
    var productLinkProps = useGenerateProductLinkPropsFn({
        token: productToken,
        brandToken: brandToken,
        impressionId: impressionId,
        selectedProductOptionToken: selectedProductOptionToken
    });
    var _productLinkProps_productUrl;
    return /*#__PURE__*/ _jsx(Link, {
        onClick: onProductClick,
        "data-test-id": "product-tile-link",
        to: (_productLinkProps_productUrl = productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.productUrl) !== null && _productLinkProps_productUrl !== void 0 ? _productLinkProps_productUrl : "",
        replace: productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.replace,
        children: children
    });
};
var useGenerateProductLinkPropsFn = function(params) {
    var productSearchString = useSearchPageProductSearchString();
    var filterKeys = useSearchPageFilterKeys();
    var location = useLocation();
    var getLinkPropsFn = handleGenerateProductLinkProps(productSearchString, params, // TODO: it looks like this field isn't used, we only pass refF to the backend on the brand page
    filterKeys || [], location);
    var linkProps = useMemo(function() {
        return getLinkPropsFn();
    }, [
        getLinkPropsFn
    ]);
    return linkProps;
};
